/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'

class SettingsModal extends Component {
  constructor(props) {
    super(props)
    console.log(props)
    this.state = {
      multiBalance: props.rowData.multiBalance || false,
      shareLandlord: props.rowData.shareLandlord || false,
      shareBalance: props.rowData.shareBalance || false,
      typeCMS: props.rowData.typeCMS || '',
    }
  }

  handleChange = (e) => {
    const { name, type, checked, value } = e.target
    this.setState({
      [name]: type === 'checkbox' ? checked : value,
    })
  };

  handleSubmit = () => {
    this.props.onSubmit(this.state, this.props.rowData)
    this.props.onHide()
  };

  render() {
    const { show, onHide } = this.props
    const { multiBalance, shareLandlord, shareBalance, typeCMS } = this.state

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Check
              type="checkbox"
              label="Multi Balance"
              name="multiBalance"
              checked={multiBalance}
              onChange={this.handleChange}
            />
            <Form.Check
              type="checkbox"
              label="Share Landlord"
              name="shareLandlord"
              checked={shareLandlord}
              onChange={this.handleChange}
            />
            <Form.Check
              type="checkbox"
              label="Share Balance"
              name="shareBalance"
              checked={shareBalance}
              onChange={this.handleChange}
            />
            <Form.Group>
              <Form.Label>Type CMS</Form.Label>
              <Form.Control
                as="select"
                name="typeCMS"
                value={typeCMS}
                onChange={this.handleChange}
              >
                <option value="">Not Selected</option>
                <option value="subscription">Subscription</option>
                <option value="share_revenue">Share Revenue</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default SettingsModal
